/*============Get Auth Controller
 ================================*/
angular
  .module('vppApp')
  .controller('getAuthController', getAuthController);

getAuthController.$inject = ['$rootScope', '$scope', 'titlecaseFilter', 'dobFilter', '$state', 'apiFactory', 'AuthenticationService', 'CustomerService', 'GetAuthDetailsService', 'ProgramInfoService', 'vppConfig', '$timeout', 'DTMTrackerService', 'TimeOutService'];

function getAuthController($rootScope, $scope, titlecaseFilter, dobFilter, $state, apiFactory, AuthenticationService, CustomerService, GetAuthDetailsService, ProgramInfoService, vppConfig, $timeout, DTMTrackerService, TimeOutService) {
  console.log(ProgramInfoService.getProgram());
  if (GetAuthDetailsService.getSuccessfull() && $state.current.name === 'get-auth') {
    GetAuthDetailsService.resetAuthData();
    delete $scope.authTemplateType;
    delete $scope.useCanadaZip;
    delete $scope.govEmployee;
    delete $scope.standardGovCopy;
    delete $scope.termsAndConditions;
  };
  var savedData = GetAuthDetailsService.get(),
    accountId = AuthenticationService.getAuthenticatedID(),
    _updateAccountFor = vppConfig.folderPath,
    _authenticationContentPath = vppConfig.authorizationContentPath;

  $scope.showEmailField = false;
  $scope.eventHandlerRan = false;

  if (savedData.fields) {
    $scope.fields = savedData.fields;
  }

  if (AuthenticationService.isAuthenticated()) {
    /* get user data */
    $scope.customerDetails = CustomerService.getCustomerData();
  }

  $scope.authorizationNum = savedData.authorizationNum;
  $scope.authorizationType = savedData.authorizationType;
  $scope.authresponse = savedData.authresponse;
  $scope.accountInfo = savedData.accountInfo;
  $scope.useCanadaZip = savedData.useCanadaZip;
  $scope.govEmployee = savedData.govEmployee;
  $scope.standardGovCopy = savedData.standardGovCopy;
  $scope.authTemplateType = savedData.authTemplateType;
  $scope.termsAndConditions = savedData.termsAndConditions;
  $scope.submittedRelationship = savedData.submitData.relationship;
  $scope.submittedFirstName = savedData.submitData.purchaserFirstName;
  $scope.submittedLastName = savedData.submitData.purchaserLastName;
  $scope.partnerName = savedData.partnerName;
  $scope.subsidiaryName = savedData.subsidiaryName;
  $scope.programID = ProgramInfoService.getProgram(); // || '284440';
  $scope.programCode = ProgramInfoService.getProgramCode(); // || 'SVPP2';
  $scope.programName = ProgramInfoService.getProgramName();
  $scope.programExp = ProgramInfoService.getProgramExp(); // || 'GM Supplier Discount';
  $scope.refreshDate = ProgramInfoService.getRefreshDate();
  $scope.programUnMasked = ProgramInfoService.getProgramKBA();
  $scope.siteCode = _updateAccountFor;
  //$scope.useTPL = true;
  $scope.onStarPrograms = ['ONG', 'ONP', 'ONS', 'ONE', 'ONC', 'ONM', 'ONF'];
  $scope.isOnStar = $scope.onStarPrograms.indexOf($scope.programCode) > -1;

  //$scope.makeOptions = {};
  //$scope.yourEmail = AuthenticationService.getUserEmail();
  $scope.yourEmail = "noreply@gm.com";

  function convertModelValues(obj) {

    var robj = {};

    Object.keys(obj).forEach(function (key) {

      // console.log(key, obj[key]);
      var year = obj[key];
      robj[key] = {};

      Object.keys(year).forEach(function (key2) {
        var make = year[key2];
        robj[key][key2] = {};
        // console.log(key2, make);

        Object.keys(make).forEach(function (key3) {
          var model = make[key3];
          robj[key][key2][key3] = {
            0: Object.keys(model)[0]
          };
        });

      });

    });
    return robj;
  }

  //console.log('pInfo:', $scope.programID, $scope.programCode, $scope.authTemplateType);
  //
  // console.log('programInfo Service ', ProgramInfoService.getProgramInfo());
  $scope.authProgramInfo = ProgramInfoService.getProgramInfo();
  // console.log('$scope.authProgramInfo', $scope.authProgramInfo);
  //////
  $scope.purchaserRelationships = $scope.authProgramInfo.purchaserRelationship;
  // console.log($scope.purchaserRelationships);
  setSiteAuthValues(_updateAccountFor, $scope.authProgramInfo);
  $scope.remainingEntitlements = $scope.authProgramInfo.remainingEntitlements;
  $scope.showRemainingAuths = $scope.authProgramInfo.remainingAuths;
  $scope.userSuspension = $scope.authProgramInfo.suspension;
  $scope.useTPL = $scope.authProgramInfo.moduleResponse.agencyConfigMap.tpl != null;
  $scope.kbaEnabled = $scope.authProgramInfo.moduleResponse.agencyConfigMap.kbv != null;
  $scope.purchaserNameReq = $scope.authProgramInfo.purchaserNameReqFlag.toLowerCase();
  if ($scope.kbaEnabled) {
    $scope.kbaMaskedAuth = $scope.programUnMasked === false ? 'true' : 'false';
    DTMTrackerService.updatePageLoadData('authType', 'Masked Authentication Number');
    //DTMTrackerService.updatePageLoadData('authCode', aupthNum);
  } else {
    DTMTrackerService.updatePageLoadData('authType', 'UnMasked Authentication Number');
  }


  if (!$scope.fields.relationship) {
    $scope.fields.relationship = null;
  }

  if (typeof $rootScope.varientData !== 'undefined' && typeof $rootScope.varientData.varient !== 'undefined') {
    $scope.isSOTY = $rootScope.varientData.varient === 'soty';
  } else {
    $scope.isSOTY = false;
  }

  if ($scope.useTPL) {
    getTPLData($scope.authProgramInfo);
  }
  if ($state.current.name === 'get-auth') {
    DTMTrackerService.directCall('get-auth-start');
  }
  if ($scope.remainingEntitlements <= 0) {
    $scope.entitlementsExceeded = true;
  }

  // generate event handler
  // on route change success
  // we have to do it this way instead of on view content loaded because
  // multiple pages are using the same controller, so the controller
  // is already loaded before we're on the proper page
  $scope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
    if ($scope.siteCode == 'emp' && ($scope.programCode == 'PEP' || $scope.programCode == 'PEPCONT' || $scope.programCode == 'GMS' || $scope.programCode == 'YOS5' || $scope.programCode == 'YOS20' || $scope.programCode == 'GMSANI' || $scope.programCode == 'GMSDD' || $scope.programCode == 'GMFEXEC' || $scope.programCode == 'USEXEC' || $scope.programCode == 'MKTEXEC' || $scope.programCode == 'LTIEXEC' || $scope.programCode == 'SDFF2' || $scope.programCode == 'SDFF2SF' || $scope.programCode == 'SDFFEV' || $scope.programCode == 'EVEXEC')) {
      if (toState.url == '/get-authorization-number/step-2/') {
        $timeout(function () {
          generateEventHandler();
        }, 100);
      }
    }
  });



  /* apiFactory.authProgram(accountId, $scope.programID).then(function(response) {
     console.log('authprogram response', response);

     $scope.purchaserRelationships = $scope.authProgramInfo.purchaserRelationship;
     console.log($scope.purchaserRelationships);
     setSiteAuthValues(_updateAccountFor, $scope.authProgramInfo);
     $scope.remainingEntitlements = $scope.authProgramInfo.remainingEntitlements;
     $scope.showRemainingAuths = $scope.authProgramInfo.remainingAuths;
     $scope.userSuspension = $scope.authProgramInfo.suspension;
     $scope.useTPL = $scope.authProgramInfo.moduleResponse.agencyConfigMap.tpl != null;
     $scope.kbaEnabled = $scope.authProgramInfo.moduleResponse.agencyConfigMap.kbv != null;
     $scope.purchaserNameReq = $scope.authProgramInfo.purchaserNameReqFlag.toLowerCase();
     console.log("KBA Enabled " + $scope.kbaEnabled);*/
  /*if (!$scope.fields.relationship) {
    $scope.fields.relationship = null;
  }




  if ($scope.useTPL) {
    getTPLData(response);
  }
  if ($state.current.name === 'get-auth') {
    DTMTrackerService.directCall('get-auth-start');
  }
  if ($scope.remainingEntitlements <= 0) {
    $scope.entitlementsExceeded = true;
  }

  }
  , function(response) {
  //console.log('authprogram error', response);

  if (response.data.errors[0].errorCode == '9050') {
    $scope.entitlementsExceeded = true;
  }

  TimeOutService.checkAuthError(response);
  });*/

  function getTPLData(_responseProgramDetails) {
    var _purchaseTimeFrame = _responseProgramDetails.moduleResponse.agencyConfigMap.tpl.purchaseTimeFrame;
    var _dealerRangeMap = _responseProgramDetails.moduleResponse.agencyConfigMap.tpl.dealerRangeMap;
    var _leadsVOIValue = _responseProgramDetails.moduleResponse.agencyConfigMap.tpl.LeadsVOIEligibility;
    var _purchaseTimeFrameOrdered = {};
    Object.keys(_purchaseTimeFrame).sort().forEach(function (key) {
      _purchaseTimeFrameOrdered[key] = _purchaseTimeFrame[key];
    });
    $scope.purchaseTimeFrame = _purchaseTimeFrameOrdered;
    $scope.dealerRangeMap = _dealerRangeMap;
    $scope.fields.range = '25';
    /// TPL Module
    apiFactory.vehicleInformation(_leadsVOIValue, $scope.programID).then(function (response) {
      $scope.makeOptions = response.data.data; //convertModelValues(response.data.data);
      // console.log("makeoptions: ", $scope.makeOptions);
    }, function (response) {
      //console.log("vehicle info error", response.data.errors);
    });
  }

  // site specific Vars
  function setSiteAuthValues(_isSite, _responseProgramDetails) {
    //console.log('setSiteAuthValues ',  _responseProgramDetails);
    switch (_isSite) {
      case "sup":
        // $scope.partnerName = _responseProgramDetails.moduleResponse.agencyConfigMap.partnerClientCode.partnerName;
        // $scope.partnerId = _responseProgramDetails.moduleResponse.agencyConfigMap.partnerClientCode.partnerId;
        // $scope.subsidiaryId = _responseProgramDetails.moduleResponse.agencyConfigMap.partnerClientCode.subsidiaryId;
        // $scope.subsidiaryName = _responseProgramDetails.moduleResponse.agencyConfigMap.partnerClientCode.subsidiaryName;

        $scope.partnerName = $scope.customerDetails.customer.companyName;
        $scope.partnerId = $scope.customerDetails.customer.companyCode;
        $scope.subsidiaryId = $scope.customerDetails.customer.companyCode;

        // API currently only uses Subsidiary Names as the main company 8/28/19
        // $scope.subsidiaryName = $scope.customerDetails.customer.companyName;

        break;
      case "ded":
        //$scope.serviceBranch = ModuleService.getModuleDetailsMPPServiceBranch();
        // $scope.mppStatus = ModuleService.getModuleDetailsMPPStatus();
        break;
      case "mpp":
        //$scope.serviceBranch = ModuleService.getModuleDetailsMPPServiceBranch();
        // $scope.mppStatus = ModuleService.getModuleDetailsMPPStatus();
        break;
      case "gmed":
        //$scope.gmedPosition = ModuleService.getModuleDetailsGMEDPosition();
        //$scope.gmedSchoolType = ModuleService.getModuleDetailsGMEDSchoolType();
        break;
      case "cgp":
        //$scope.cgpStates = ModuleService.getModuleDetailsCGPStates();
        //$scope.cgpCollegeLevel = ModuleService.getModuleDetailsCGPCollegeLevel();
        break;
      case "emp":
        $scope.survey = _responseProgramDetails.moduleResponse.agencyConfigMap.survey;
        processServeyQs();
        break;
      default:
    }
    // set up dropdown data
  }
  // create scroll event handler to enable checkbox
  // once user scrolls to bottom of scroll rules scroll box
  // this is for get-auth-step-2.html
  function generateEventHandler() {
    if (!$scope.eventHandlerRan) {
      var scrollboxes = document.getElementsByClassName('authorization-rules');

      if (typeof (scrollboxes) != 'undefined' && scrollboxes != null) {
        var scrollbox = scrollboxes[0];
        var checkbox = document.getElementById('relationship-agree');

        // create scroll event handler
        scrollbox.addEventListener('scroll', function () {
          if ((scrollbox.scrollTop + scrollbox.offsetHeight) >= scrollbox.scrollHeight) {
            checkbox.disabled = false;
          } else {
            checkbox.disabled = true;
          }
        });
      }
      $scope.eventHandlerRan = true;
    }
  }
  // get profile details:
  // if(!$scope.accountInfo.accountDetails) {
  apiFactory.getCustomer(accountId).then(function (response) {
    //console.log('getCustomer response', response);
    $scope.programDetails = response.data.programDetails;
    $scope.customerDetails = response.data.customerDetails;
    $scope.userName = $scope.customerDetails.firstName + ' ' + $scope.customerDetails.lastName;

    if (!$scope.fields.emailAddress || $scope.fields.emailAddress == '' || $scope.fields.emailAddress == 'default@gmail.com') {
      $scope.fields.emailAddress = AuthenticationService.getUserEmail() || $scope.customerDetails.emailAddress;
    }
    $scope.state = $scope.customerDetails.stateInclPR;
    // $scope.fields.zipCode = $scope.customerDetails.zipCode;
    $scope.city = titlecaseFilter($scope.customerDetails.city);

  }, function errorCallback(response) {
    //console.log('getCustomer error', response);
    $state.go('sign-in');
    TimeOutService.checkAuthError(response);
  });

  // save email address from field on Step 2
  $scope.searchByDealer = function () {
    $scope.showResults = true;
  };

  $scope.saveEmail = function (b) {
    // $scope.showEmailField = b;
    var data = GetAuthDetailsService.get();
    data.fields.emailAddress = $scope.fields.emailAddress;
    data.submitData.emailAddress = $scope.fields.emailAddress;
    GetAuthDetailsService.set(data);
  };

  // Go back to step 1
  $scope.backToStep1 = function () {
    $state.go('get-auth');
  };

  $scope.locateDealerByZip = function () {
    var getParams = $scope.fields.make + '/' + $scope.fields.zipCode + '/' + $scope.fields.range;
    locateDealer(getParams);
  };

  $scope.locateDealerByCity = function () {
    var getParams = $scope.fields.make + '/' + $scope.fields.city + '/' + $scope.fields.state + '/' + $scope.fields.range;
    locateDealer(getParams);
  };

  $scope.locateDealerByName = function () {
    //GET /dealer/{make}/byName/{name}/{city}/{state}
    var getParams = $scope.fields.make + '/byName/' + $scope.fields.dealername + "/" + $scope.fields.city + '/' + $scope.fields.state;
    locateDealer(getParams);
  };

  // Updated 9/12/2019
  function locateDealer(getParams) {
    apiFactory.findDealerForm(getParams)
      .then(function successSignOut(response) {
        var responseData = response.data.dealerResultsVO;

        var resultLength = responseData.length;
        for (var i = 0; i < resultLength; i++) {
          var phoneLength = responseData[i].phone.length;
          responseData[i].parsedPhone = {};
          for (var j = 0; j < phoneLength; j++) {
            switch (responseData[i].phone[j].type) {
              case 'dealerMain':
                responseData[i].parsedPhone.dealerMain = responseData[i].phone[j].number;
                break;
              case 'dealerFax':
                responseData[i].parsedPhone.dealerFax = responseData[i].phone[j].number;
                break;
            }
          }

        }
        $scope.dealerResults = responseData;

      }, function errorCallback(response) {
        //console.log(response.data.errors);
        $scope.dealerResults = [];
        $scope.serverError = response.data.errors;
      });
    $scope.selectedDealer = null;
    $scope.showResults = true;
  };

  $scope.selectDealer = function (vendorID) {
    $scope.selectedDealer = vendorID;
    //console.log('selectedDealer: ', $scope.selectedDealer);
  };
  // Save field data to service
  $scope.saveData = function () {
    //console.log('saveData', $scope.authTemplateType);
    var data = {
      submitData: {
        // accountID: AuthenticationService.getAuthenticatedID(),
        programID: $scope.programID,
        programCode: $scope.programCode,
        authDetails: {
          dateOfBirth: dobFilter($scope.fields.birthDate)
        },
        relationship: $scope.fields.relationship,
        //// Modules
        moduleDetails: {},
        //// End Modules
        emailAddress: $scope.fields.emailAddress,
        secondaryPassword: "string",
        disclaimerAudit: $scope.fields.informationIsAccurate,
        rulesAndGuidelinesAudit: $scope.fields.rulesGuidelinesAgree
      },
      authresponse: $scope.authresponse,
      accountInfo: $scope.accountInfo,
      fields: $scope.fields,
      zipCode: $scope.zip,
      companyName: $scope.companyName,
      birthDate: $scope.dob,
      useCanadaZip: $scope.useCanadaZip,
      govEmployee: $scope.govEmployee,
      standardGovCopy: $scope.standardGovCopy,
      authTemplateType: $scope.authTemplateType,
      termsAndConditions: $scope.termsAndConditions,
      authorizationNum: $scope.authorizationNum,
      authorizationType: $scope.authorizationType
    };

    if ($scope.useCanadaZip) {
      //console.log("using canada zip");
      data.submitData.authDetails.postalCodeUSCanada = $scope.fields.zipCodeCanada;
    } else {
      data.submitData.authDetails.postalCode = $scope.fields.zipCode;
    }

    if ($scope.userSuspension) {
      data.submitData.secondaryPassword = $scope.fields.secondaryPassword;
    }
    // w/ TPL
    if ($scope.useTPL) {
      var _tempTPL = {};
      _tempTPL = {
        "tpl": {
          hasDealerContacted: $scope.fields.hasContacted, //'N', //"Y" without TPL
          selectedDealers: $scope.selectedDealer, //vendorCode (5 digits), vendorId (6 digits, more likely)
          vehicleYear: $scope.fields.year,
          vehicleMake: $scope.fields.make, // 'BUICK',
          vehicleModel: $scope.fields.model, //'Enclave',
          selectedTimeFrame: $scope.fields.timeframe //'04'
        }
      };
      //console.log('_tempTPL ~ ', _tempTPL);
      var _tempMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempTPL);
      //console.log(data.submitData);

    }

    // w/ Partner Code - partnerClientCode (SUP && DED)
    if (_updateAccountFor === "sup") {
      var _tempPCC = {};
      _tempPCC = {
        partnerClientCode: {
          partnerId: $scope.partnerId,
          subsidiaryId: $scope.subsidiaryId
        }
      };
      //console.log('_tempPCC ~ ', _tempPCC);
      var _tempPCCMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempPCC);
      //console.log(data.submitData);
      data.partnerName = $scope.partnerName;
      data.subsidiaryID = $scope.subsidiaryName;
    }


    // Template A && G
    /* "govtempauth": {
     "govEmployee": "Yes, Approval granted from GM"
     },
     "relationshipaudit": {
     "relationshipAudit": "AGREED"
     }*/
    if ($scope.authTemplateType === 'template-a' || $scope.authTemplateType === 'template-g') {
      var _tempGovTempAuth = {};
      _tempGovTempAuth = {
        govtempauth: {
          govEmployee: $scope.fields.govtEmployee
        },
        "relationshipaudit": {
          relationshipAudit: "AGREED"
        }
      };
      $scope.govEmployee = $scope.fields.govtEmployee;
      //data.submitData.authDetails.postalCode = $scope.fields.govtEmployee;
      //
      var _tempGTAMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempGovTempAuth);

    }

    // Template B
    /* "govtempauth": {
     "govEmployee": "Yes, Approval granted from GM"
     },
     "relationshipaudit": {
     "relationshipAudit": "AGREED"
     }*/
    if ($scope.authTemplateType === 'template-b') {
      var _tempGovTempAuth = {};
      _tempGovTempAuth = {
        govtempauth: {
          govEmployee: $scope.fields.govtEmployee
        }
      };
      $scope.govEmployee = $scope.fields.govtEmployee;
      //
      //console.log('_tempGovTempAuth B ~ ', _tempGovTempAuth);
      var _tempGTAMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempGovTempAuth);
      //console.log(data.submitData);
    }

    // Template D
    /* "govtempauth": {
     "govEmployee": "Yes, Approval granted from GM"
     },
     "relationshipaudit": {
     "relationshipAudit": "AGREED"
     }*/
    if ($scope.authTemplateType === 'template-d') {
      var _tempGovTempAuth = {};
      _tempGovTempAuth = {
        govtempauth: {
          govEmployee: $scope.fields.govtEmployee
        },
        survey: {
          // $scope.fields.survey.conquestSale
        }
      };
      // SURVEY
      for (var key in $scope.fields.survey) {
        var itemcode = key.split('-')[1];
        //console.log("Survey element: ", itemcode, $scope.fields.survey[key]);
        _tempGovTempAuth.survey[itemcode] = $scope.fields.survey[key];
      }

      if (Object.keys($scope.fields.survey).length === 3) {
        _tempGovTempAuth.survey[$scope.survey.elements[1].code] = 'string';
      }
      //
      var _tempGTAMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempGovTempAuth);
      //console.log(data.submitData);
    }

    // Template E
    /* "govtempauth": {
     "relationshipaudit": {
     "relationshipAudit": "AGREED"
     }*/
    if ($scope.authTemplateType === 'template-e') {
      var _tempGovTempAuth = {};
      _tempGovTempAuth = {
        "relationshipaudit": {
          relationshipAudit: "AGREED"
        }
      };
      //data.submitData.authDetails.postalCode = $scope.fields.govtEmployee;
      //
      var _tempGTAMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempGovTempAuth);
    }

    // Template G
    /* "govtempauth": {
     "govEmployee": "Yes, Approval granted from GM"
     },
     "relationshipaudit": {
     "relationshipAudit": "AGREED"
     }*/
    if ($scope.authTemplateType === 'template-g') {
      var _tempGovTempAuth = {};
      _tempGovTempAuth = {
        govtempauth: {
          govEmployee: $scope.fields.govtEmployee
        },
        "relationshipaudit": {
          relationshipAudit: "AGREED"
        }
      };
      $scope.govEmployee = $scope.fields.govtEmployee;
      //
      //console.log('_tempGovTempAuth B ~ ', _tempGovTempAuth);
      var _tempGTAMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempGovTempAuth);
      //console.log(data.submitData);
    }

    if ($scope.purchaserNameReq === 'y') {
      data.submitData.purchaserFirstName = $scope.fields.purchaserFirstName;
      data.submitData.purchaserLastName = $scope.fields.purchaserLastName;
    }

    if ($scope.kbaEnabled) {
      var _tempKBA = {};
      _tempKBA = {
        "kbv": {
          valid: String(ProgramInfoService.getProgramKBA()) // can be true or false, false is masked
        }
      };
      //console.log('_tempTPL ~ ', _tempTPL);
      var _tempMerge = angular.merge(data.submitData.moduleDetails, data.submitData.moduleDetails, _tempKBA);
      //console.log(data.submitData);

    }

    // Default Templates - No Modules - Template H,

    GetAuthDetailsService.set(data);
    //console.log("savedData", data);
    return data;
  };



  // go to Step 2
  $scope.submitReview = function (theform) {
    // theform.$submitted = true;
    //console.log('theform, ' + theform.$invalid);
    $scope.$broadcast('$validate');
    if (!theform.$invalid) {
      //console.log('form is valid');
    }
  };

  $scope.review = function () {
    //console.log('submit()');
    var data = $scope.saveData();
    //console.log('submit data', data);

    $state.go("get-auth-step2");
  };

  $scope.submit = function () {
    $scope.responsePending = true;

    //$scope.selectedDealer = savedData.submitData.moduleDetails.tpl.selectedDealers;
    //var data = $scope.saveData();
    var data = GetAuthDetailsService.get();
    data.submitData.rulesAndGuidelinesAudit = $scope.fields.rulesGuidelinesAgree;
    console.log('submit data', data.submitData);


    // $state.go('get-auth.complete');

    apiFactory.authorization(accountId, angular.toJson(data.submitData)).then(function successCallback(response) {
      $scope.authresponse = response.data;
      // let hyphenIndex = $scope.authresponse.authorizationNumber.indexOf("-");
      // if (hyphenIndex > 0 && hyphenIndex < $scope.authresponse.authorizationNumber.length) {
      //   $scope.authorizationNum = $scope.authresponse.authorizationNumber.slice(0, hyphenIndex - 1);
      //   console.log("authorization number: " + $scope.authorizationNum);
      //   console.log("authorization type: " + $scope.authorizationType);
      //   $scope.authorizationType = $scope.authresponse.authorizationNumber.slice(hyphenIndex + 1);
      //   console.log("authorization type: " + $scope.authorizationType);

      // }
      let authorizationNumberParts;

      if ($scope.authresponse.authorizationNumber && $scope.authresponse.authorizationNumber.indexOf("-") > -1) {
        authorizationNumberParts = $scope.authresponse.authorizationNumber.split("-");
        $scope.authorizationNum = authorizationNumberParts[0];
        $scope.authorizationType = authorizationNumberParts[1];
        //console.log("authorization type: " + $scope.authorizationType);
        //console.log("authorization number: " + $scope.authorizationNum);

      }
      $scope.authNum = response.data.authorizationNumber;
      $scope.saveData();
      GetAuthDetailsService.setAuthSuccess();
      // DTMTrackerService.updatePageLoadData('authCode', authNum);
      DTMTrackerService.directCall('get-auth-complete');
      delete $scope.responsePending;
      $state.go('get-auth-complete');
    }, function errorCallback(response) {
      //console.log(response.data.errors);
      $scope.serverError = response.data.errors;
      TimeOutService.checkAuthError(response);
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.passPopUpTitle = function (title) {
    $scope.popUpConfirmationTitle = title;
  }

  var ranOnce = false;
  var chosenTemplate = '';
  //var chosenTPLTemplate = '';
  $scope.getModuleInclude = function () {

    // angular's $digest keeps running this so we want to stop that
    // from happening once it sets the correct template filename

    if (chosenTemplate == '') {

      // var _tempString = "";

      // if($scope.useTPL) {
      var modulefilename;
      switch ($scope.programCode.toLowerCase()) {
        case 'gms':
        case 'yos5':
        case 'yos20':
        case 'lti':
        case 'ong':
        case 'onp':
        case 'gmevtour':
        case 'gmevtourev':
          // $scope.requireRelationshipAgree = true;
          $scope.authTemplateType = "template-a";
          $scope.useCanadaZip = true;
          $scope.govEmployee = true;
          $scope.standardGovCopy = false;
          modulefilename = 'emp/get-auth-template-a.html';
          break;

        case 'fpoc2':
        case 'gmcs':
        case 'gmcsv':
          // $scope.requireRelationshipAgree = true;
          $scope.authTemplateType = "template-a";
          $scope.useCanadaZip = false;
          $scope.govEmployee = true;
          $scope.standardGovCopy = false;
          modulefilename = 'emp/get-auth-template-a.html';
          break;

        case 'gmsev':
          $scope.requireRelationshipAgree = false;
          $scope.authTemplateType = "template-a";
          $scope.useCanadaZip = true;
          $scope.govEmployee = true;
          $scope.standardGovCopy = false;
          modulefilename = 'emp/get-auth-template-a.html';
          break;

        case 'uawvpa':
          $scope.useCanadaZip = true;
          $scope.purchaserNameReq = 'n';
          $scope.standardGovCopy = false;
          $scope.authTemplateType = "template-default";
          modulefilename = 'global/tpl-module-default.html';
          break;

        case 'accdisc':
          $scope.authTemplateType = "template-a";
          modulefilename = 'emp/get-auth-template-a.html';
          $scope.standardGovCopy = false;
          // $scope.requireRelationshipAgree = true;
          break;

        case 'sdff2':
          $scope.authTemplateType = "template-b";
          modulefilename = 'emp/get-auth-template-b.html';
          break;

        case 'sdff2ev':
          $scope.authTemplateType = "template-b";
          modulefilename = 'emp/get-auth-template-b.html';
          break;

        case 'sdff2sf':
          $scope.authTemplateType = "template-b";
          modulefilename = 'emp/get-auth-template-b.html';
          break;

        case 'gmcs-old':
          $scope.authTemplateType = "template-c";
          $scope.govEmployee = true;
          $scope.standardGovCopy = false;
          modulefilename = 'emp/get-auth-template-c.html';
          break;

        case 'mktexec':
        case 'usexec':
        case 'evexec':
        case 'gmfexec':
        case 'ltiexec':
          $scope.authTemplateType = "template-d";
          modulefilename = 'emp/get-auth-template-d.html';
          $scope.useCanadaZip = true;
          break;

        case 'gmsdd':
          $scope.authTemplateType = "template-e";
          modulefilename = 'emp/get-auth-template-e.html';
          // $scope.requireRelationshipAgree = true;
          break;

        case 'gmfappcert1g':
        case 'gmfappcert2g':
        case 'gmfappcert3g':
        case 'gmfappcert5':
        case 'gmfappcert6':
        case 'gmfappcert7':
          $scope.authTemplateType = "template-f";
          $scope.useCanadaZip = true;
          $scope.termsAndConditions = _authenticationContentPath + "emp/get-auth-template-f-terms-and-conditions-financial.html";
          modulefilename = 'emp/get-auth-template-f.html';
          break;

        // "grandfathered" EAC variant
        case 'appcert1g':
        case 'appcert2g':
        case 'appcert3g':
          $scope.authTemplateType = "template-f";
          $scope.useCanadaZip = true;
          $scope.termsAndConditions = _authenticationContentPath + "emp/get-auth-template-f-terms-and-conditions-general-grandfathered.html";
          modulefilename = 'emp/get-auth-template-f.html';
          break;

        case 'gmeac':
        case 'gmappcert5':
        case 'gmappcert6':
        case 'gmappcert7':
          $scope.authTemplateType = "template-f";
          $scope.useCanadaZip = true;
          $scope.termsAndConditions = _authenticationContentPath + "emp/get-auth-template-f-terms-and-conditions-general.html";
          modulefilename = 'emp/get-auth-template-f.html';
          break;

        case 'pep':
          $scope.authTemplateType = "template-g";
          modulefilename = 'emp/get-auth-template-g.html';
          $scope.useCanadaZip = true;
          $scope.standardGovCopy = false;
          // $scope.requireRelationshipAgree = true;
          break;

        case 'pepcont':
          $scope.authTemplateType = "template-g";
          modulefilename = 'emp/get-auth-template-g.html';
          $scope.useCanadaZip = true;
          $scope.standardGovCopy = false;
          // $scope.requireRelationshipAgree = true;
          break;

        case 'gmsani':
          $scope.authTemplateType = "template-h";
          modulefilename = 'emp/get-auth-template-h.html';
          break;

        case 'svpp2':
        case 'cgp':
        case 'gmed':
        case 'disp':
        case 'frd':
          $scope.authTemplateType = "template-default";
          modulefilename = 'global/tpl-module-default.html';
          break;

        case 'gmdlr':
        case 'gmdlr3':
        case 'soty25':
        case 'soty25ev':
        case 'spl2':
        case 'spl2ev':
        case 'hbcash17':
        case 'ons':
        case 'one':
        case 'onc':
        case 'onm':
        case 'onf':
        case 'gmdlrev':

          // no TPL
          $scope.authTemplateType = "template-no-tpl";
          modulefilename = 'global/no-tpl.html';
          break;

        default:
          $scope.authTemplateType = "template-default";
          modulefilename = 'global/tpl-module-default.html';
          break;
      }
      chosenTemplate = _authenticationContentPath + modulefilename;

      //chosenTPLTemplate = '/content/html/partials/authorization/' + modulefilename;
      // }
      //console.log($scope.empRulesGuidelines);
      //console.log('Template Type '+$scope.authTemplateType);

      //console.log('ModuleInclude ', chosenTemplate);

      // console.log('$scope.requireRelationshipAgree: ', $scope.requireRelationshipAgree);
      // console.log('agreeform: ', agreeform);
      // if($scope.fields.relationshipAgree === undefined) {
      /*if ($scope.agreeform !== null) {
        $scope.fields.relationshipAgree = false;
      } else {
        $scope.fields.relationshipAgree = true;
      }*/
      // }

    }
    return chosenTemplate;
    //return chosenTPLTemplate;
  };

  $scope.getSiteSpecificNextSteps = function () {
    var _tempString = "/content/html/partials/authorization/" + _updateAccountFor + "/get-auth-complete-next-steps.html";
    return _tempString;
  };

  // submits Email Auth Form
  // Updated 9/12/2019
  $scope.submitForm = function (email) {
    var accountID = AuthenticationService.getAuthenticatedID();
    var authorizationCode = $scope.authresponse.authorizationNumber;
    var emailInfo = email;

    apiFactory.authEmail(accountID, authorizationCode, emailInfo).then(function () {
      $scope.toggleModal();
      $scope.toggleModal('emailSentConfirmation');
    }, function errorCallback(response) {
      $scope.responsePending = false;
      $scope.serverError = response.data.errors;

    });
  };

  $scope.submitFormGMDomain = function (email) {
    var accountID = AuthenticationService.getAuthenticatedID();
    var authorizationCode = $scope.authresponse.authorizationNumber;
    var emailObj = email;
    var emailInfo = {
      recipientEmail: emailObj.emailname + email.emaildomain
    }

    apiFactory.authEmail(accountID, authorizationCode, emailInfo).then(function () {
      $scope.toggleModal();
      $scope.toggleModal('emailSentConfirmation');
    }, function errorCallback(response) {
      $scope.responsePending = false;
      $scope.serverError = response.data.errors;

    });
  };
  $scope.surveyConguestSaleRequired = function (conquestFieldValue) {
    var _requiredField = ((conquestFieldValue === '172' || conquestFieldValue === '170') ? true : false);
    return _requiredField;
  };

  function processServeyQs() {
    if ($state.current.name === 'get-auth-step2' && $scope.authTemplateType === "template-d") {
      $scope.conquestSale = ((savedData.submitData.moduleDetails.survey[$scope.survey.elements[0].code] === '172' || savedData.submitData.moduleDetails.survey[$scope.survey.elements[0].code] === '170') ? 'Yes' : 'No');
      $scope.conquestVehicle = ((savedData.submitData.moduleDetails.survey[$scope.survey.elements[1].code] === 'string') ? '' : savedData.submitData.moduleDetails.survey[$scope.survey.elements[1].code]);
      $scope.conquestCurrVehicle = savedData.submitData.moduleDetails.survey[$scope.survey.elements[2].code];
      $scope.conquestCurrVehicleVin = savedData.submitData.moduleDetails.survey[$scope.survey.elements[3].code];
    }
  };

  $scope.getRulesnConditions = function () {
    var _theRulesTemplate;
    var _templatefilename;
    switch ($scope.programCode.toLowerCase()) {
      case 'lti':
      case 'appcert1g':
      case 'appcert2g':
      case 'appcert3g':
      case 'GMFAPPCERT1G':
      case 'GMFAPPCERT2G':
      case 'GMFAPPCERT3G':

        _templatefilename = 'emp/get-auth-rules-and-guidelines.html';
        break;

      case 'pep':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-pep.html';
        break;

      case 'pepcont':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-pepcont.html';
        break;

      case 'yos5':
      case 'yos20':
      case 'gms':
      case 'gmeac':
      case 'gmevtour':
      case 'gmevtourev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-yos-gms-program.html';
        break;

      case 'gmsdd':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsdd.html';
        break;

      case 'gmcs':
      case 'gmcsv':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-certified-service.html';
        break;

      case 'sdff2ev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-sdff2ev.html';
        break;

      case 'sdff2':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-supplier-for-friends.html';
        break;

      case 'sdff2sf':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-supplier-discount-for-friends.html';
        break;

      case 'gmsani':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsani.html';
        break;

      case 'mktexec':
      case 'usexec':
      case 'ltiexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-exec-program.html';
        break;

      case 'accdisc':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-accessories-discount.html';
        break;

      case 'gmfexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-financial-exec-program.html';
        break;

      case 'fpoc2':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-fpoc.html';
        break;
      case 'gmdlr':
      case 'gmdlr3':
        _templatefilename = 'ded/get-auth-rules-and-guidelines-gmdlr-discount.html';
        break;

      case 'ong':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-ong-program.html';
        break;

      case 'onp':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-onp-program.html';
        break;

      case 'gmsev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsev.html';
        break;

      case 'evexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-evexec.html';
        break;

      case 'gmdlrev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmdlrev.html';
        break;

      case 'svpp2ev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-svpp2ev.html';

      case 'uawvpa':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-uaw.html';
        break;

      default:
        _templatefilename = 'emp/get-auth-rules-and-guidelines.html';
        break;
    }
    _theRulesTemplate = _authenticationContentPath + _templatefilename;
    return _theRulesTemplate;

  };

};
